/**
 * Számla manuális-előleg derivációja (bug-screen #5).
 *
 * Ha a felhasználó SZÁZALÉKOT ad meg, az előleg a LIVE bruttó-végösszegből
 * számolódik (követi a tétel-változást) — a korábbi kód befagyasztotta egy fix
 * összegbe, így tétel-hozzáadás/-törlés után a finalTotal hibás (over/undercharge)
 * lett. Fix összeg megadása esetén a beírt érték marad.
 */
export function deriveManualAdvance(
  grossTotal: number,
  percent: number | null,
  amount: number | null
): number {
  if (percent != null && percent > 0) {
    return Math.round(grossTotal * (percent / 100));
  }
  return amount ?? 0;
}
